import { AppRoutePath } from 'config/constants';
import { matchPath } from 'react-router-dom';

export const toDisplayCase = (s: string) =>
  s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
export const QS_CURRENT_CASE_ID = 'current';

export const getWardCaseSmidFromQueryParams = (): Nullable<string> => {
  let url: URL;
  try {
    url = new URL(window.location.href);
  } catch (e) {
    return null;
  }
  const caseSmid = url.searchParams.get(QS_CURRENT_CASE_ID);
  return caseSmid;
};

/** Returns the case ID only if the current path is the WARD path */
export const getWARDCaseId = (): Nullable<string> => {
  const caseId = getWardCaseSmidFromQueryParams();
  if (isWardRoute() && caseId) return caseId;
  return null;
};

/** Returns true if the current path is the WARD route */
export const isWardRoute = (): boolean =>
  !!matchPath(AppRoutePath.VIEWER_WARD, window.location.pathname);
